import { filterData } from "../../../common/helper"
import { divideInNIntegers, formatNumber } from "../../../common/mathHelper"

export const paymentModes = [
	{ PaymentTypeInt: 1, name: 'Paid' },
	{ PaymentTypeInt: 2, name: 'To Pay' },
	{ PaymentTypeInt: 3, name: 'FOC' },
	{ PaymentTypeInt: 4, name: 'COD' },
	{ PaymentTypeInt: 5, name: 'On Account' },
	{ PaymentTypeInt: 6, name: 'Paid (Manual)' },
	{ PaymentTypeInt: 7, name: 'To Pay (Manual)' },
	{ PaymentTypeInt: 8, name: 'Self' },
	{ PaymentTypeInt: 9, name: 'ToPay (DDDV)' },
	{ PaymentTypeInt: 10, name: 'On Account (Manual)' },
]
export function camelCase(str) {
	return str?.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
		if (+match === 0) return ''
		return index === 0 ? match.toLowerCase() : match.toUpperCase()
	})
}
export function groupDataByKey(arr = [], key) {
	return arr.reduce((groups, item) => {
		const groupKey = item[key]
		if (!groups[groupKey]) {
			groups[groupKey] = { data: [], totalNetAmount: 0, totalQuantity: 0 }
		}
		groups[groupKey].data.push(item)
		groups[groupKey].totalNetAmount += item.NetAmount
		groups[groupKey].totalQuantity += item.Quantity
		return groups
	}, {})
}
export function groupDataByVehicleAndPayment(data) {
	const groupedByVehicle = {}
	data.forEach((item) => {
		const { VehicleNo, PaymentTypeInt, NetAmount, Quantity } = item
		if (!groupedByVehicle[VehicleNo]) {
			groupedByVehicle[VehicleNo] = {
				vehicleNo: VehicleNo,
			}
			paymentModes.forEach((mode) => {
				const paymentTypeName = camelCase(mode.name)
				groupedByVehicle[VehicleNo][`${paymentTypeName}Amount`] = 0
				groupedByVehicle[VehicleNo][`${paymentTypeName}Quantity`] = 0
				groupedByVehicle[VehicleNo][`totalUnits`] = 0
				groupedByVehicle[VehicleNo][`totalAmount`] = 0
			})
		}
		const paymentMode = paymentModes.find((mode) => mode.PaymentTypeInt === PaymentTypeInt);
		const paymentTypeName = camelCase(paymentMode?.name);
		if ([2, 4, 7, 9].includes(paymentMode?.PaymentTypeInt)) {
			groupedByVehicle[VehicleNo][`${paymentTypeName}Amount`] += NetAmount
			groupedByVehicle[VehicleNo][`totalAmount`] += Number(NetAmount)
		} else {
			groupedByVehicle[VehicleNo][`${paymentTypeName}Amount`] += 0
			groupedByVehicle[VehicleNo][`totalAmount`] += 0
		}
		groupedByVehicle[VehicleNo][`${paymentTypeName}Quantity`] += Quantity
		groupedByVehicle[VehicleNo][`totalUnits`] += Number(Quantity)
	})
	const totalObject = {}
	paymentModes.forEach((mode) => {
		const paymentTypeName = camelCase(mode.name)
		if ([2, 4, 7, 9].includes(mode.PaymentTypeInt)) {
			totalObject[`${paymentTypeName}Amount`] = data
				.filter((item) => item.PaymentTypeInt === mode.PaymentTypeInt)
				.reduce((total, item) => total + item.NetAmount, 0)
		} else {
			totalObject[`${paymentTypeName}Amount`] = 0
		}
		totalObject[`${paymentTypeName}Quantity`] = data
			.filter((item) => item.PaymentTypeInt === mode.PaymentTypeInt)
			.reduce((total, item) => total + item.Quantity, 0)

	})
	const formattedTotalObject = {};
	Object.entries(totalObject).forEach(([key, value]) => {
		formattedTotalObject[key] = formatNumber(value)
	});
	formattedTotalObject.vehicleNo = 'Total'
	const result = Object.values(groupedByVehicle).map(item => {
		const newItem = {};
		Object.keys(item).forEach(key => {
			if (key === "vehicleNo") {
				newItem[key] = item[key];
			} else {
				newItem[key] = formatNumber(item[key]);
			}
		});
		return { ...newItem, dataType: "entry" };
	});
	let allTotalUnits = 0
	let allTotalAmount = 0
	result?.map((val) => {
		allTotalUnits += val.totalUnits
		allTotalAmount += val.totalAmount
	})
	formattedTotalObject.totalUnits = formatNumber(allTotalUnits)
	formattedTotalObject.totalAmount = formatNumber(allTotalAmount)
	result.push({ dataType: 'total', ...formattedTotalObject })
	return result
}
export const IsAppGroup = (array = [], key, setVehicleGroupData) => {
	var oldData = {}
	array.forEach((item) => {
		if (!(item["IsApp"] in oldData)) {
			oldData[item["IsApp"]] = []
		}
		oldData[item["IsApp"]].push(item)
	})
	let updatedData = []
	Object.keys(oldData).map((val) => {
		let arr = GroupData(oldData[val], key, setVehicleGroupData)
		updatedData = [...updatedData, ...arr]
	})
	setVehicleGroupData(updatedData)
}
export const GroupData = (array = [], key, setVehicleGroupData, cargoSettingFilterData) => {
	var newData = {}
	array.forEach((item) => {
		if (!(item[key] in newData)) {
			newData[item[key]] = []
		}
		newData[item[key]].push(item)
	})
	let quantityTotal = 0
	let frieght = 0
	let docCharge = 0
	let cartege = 0
	let hamali = 0
	let operatorHamali = 0
	let frieghtGst = 0
	let cartageGst = 0
	let hamaliTotal = 0
	let valuation = 0
	let AllOtherCharge = 0
	let NetAmountTotal = 0
	Object.keys(newData).map((val) => {
		newData[val] = newData[val]?.map((item, i) => ({ SN: i + 1, ...item }))
		newData[val].forEach((val) => {
			quantityTotal += Number(val.Quantity)
			frieght += Number(val.Freight)
			docCharge += Number(val.DocumentCharges)
			cartege += Number(val.CartageAmount)
			hamali += Number(val.HamaliCharges)
			operatorHamali += Number(val.OperatorHamaliChg)
			frieghtGst += Number(val.ServiceTaxAmount)
			cartageGst += Number(val.CartageTax)
			hamaliTotal += Number(val.OptHamaliGST)
			valuation += Number(val.Insurance)
			NetAmountTotal += Number(val.NetAmount)
			AllOtherCharge += Number(val.AllOther)
		})
		if (key === 'PaymentType') {
			newData[val].push({
				OnlyLRNo: `Total `,
				Quantity: quantityTotal.toFixed(2),
				Freight: frieght.toFixed(2),
				HamaliCharges: hamali.toFixed(2),
				CartageAmount: cartege.toFixed(2),
				Insurance: valuation.toFixed(2),
				AllOther: AllOtherCharge.toFixed(2),
				NetAmount: NetAmountTotal.toFixed(2),
			})
		} else if (key === 'VehicleNo') {
			newData[val].push({
				OnlyLRNo: `Total For Vehicle No:${val}`,
				SenderName: quantityTotal.toFixed(2),
				SenderGSTN: NetAmountTotal.toFixed(2),
				BookCity: NetAmountTotal.toFixed(2),
			})
		} else {
			if (key === 'VehicleNoFilter') {
				newData[val].push({
					PaymentType: `Total `,
					Quantity: quantityTotal.toFixed(2),
					VoucherNo: '',
					Freight: frieght.toFixed(2),
					DocumentCharges: docCharge.toFixed(2),
					CartageAmount: cartege.toFixed(2),
					HamaliCharges: hamali.toFixed(2),
					OperatorHamaliChg: operatorHamali.toFixed(2),
					ServiceTaxAmount: frieghtGst.toFixed(2),
					CartageTax: cartageGst.toFixed(2),
					OptHamaliGST: hamaliTotal.toFixed(2),
					Insurance: valuation.toFixed(2),
					NetAmount: NetAmountTotal.toFixed(2),
					// isTotalRowVWD:true
				})
			} else {
				newData[val].push({
					OnlyLRNo: `Total `,
					Quantity: quantityTotal.toFixed(2),
					VoucherNo: '',
					Freight: frieght.toFixed(2),
					DocumentCharges: docCharge.toFixed(2),
					CartageAmount: cartege.toFixed(2),
					HamaliCharges: hamali.toFixed(2),
					OperatorHamaliChg: operatorHamali.toFixed(2),
					ServiceTaxAmount: frieghtGst.toFixed(2),
					CartageTax: cartageGst.toFixed(2),
					OptHamaliGST: hamaliTotal.toFixed(2),
					Insurance: valuation.toFixed(2),
					NetAmount: NetAmountTotal.toFixed(2),
				})
			}

		}
		if (key === 'VehicleNoFilter') {
			newData[val].unshift({
				SN: key === 'PaymentType' ? ` ${val} LRs  Dispatched By ${newData[val][0]?.IsApp == 0 ? "CRS2011 DeskApp" : "Maven Application"} ` : `VehicleNo :` + val,
				DispatchDateTime: key === 'PaymentType' ? "" : key === 'VehicleNo' ? newData[val][0]?.VehicleNo : `DriverName : ` + newData[val][0].DriverConductorName + `ContactNo : ` + newData[val][0].ContactNo,
				DispatchedToBranchFilter: key === 'PaymentType' ? '' : `ContactNo : ` + newData[val][0].ContactNo,
				isSubHeading: true
			})
		} else {
			newData[val].unshift({
				SN: key === 'PaymentType' ? ` ${val} LRs  Dispatched By ${newData[val][0]?.IsApp == 0 ? "CRS2011 DeskApp" : "Maven Application"} ` : `VehicleNo :` + val,
				DispatchDateTime: key === 'PaymentType' ? "" : key === 'VehicleNo' ? newData[val][0]?.VehicleNo : `DriverName : ` + newData[val][0].DriverConductorName + `ContactNo : ` + newData[val][0].ContactNo,
				DispatchedToBranchFilter: key === 'PaymentType' ? '' : `ContactNo : ` + newData[val][0].ContactNo,
			})
		}

		quantityTotal = 0
		frieght = 0
		docCharge = 0
		cartege = 0
		hamali = 0
		operatorHamali = 0
		frieghtGst = 0
		cartageGst = 0
		hamaliTotal = 0
		valuation = 0
		NetAmountTotal = 0
	})
	const mainData = { ...newData }
	let bodyData = []
	Object.keys(mainData)?.map((item) => {
		const data = [...bodyData]
		bodyData = [...data, ...mainData[item]]
	})
	let ParcelsTotal = 0
	let allNetAmountTotal = 0
	bodyData?.map((val) => {
		if (Object.keys(val).length === 4) {
			ParcelsTotal += Number(val.SenderName)
			allNetAmountTotal += Number(val.SenderGSTN)
		}
	})
	if (key === 'VehicleNo') {
		bodyData?.push({
			LRNO: `Total For ALL Vehicles:`,
			SenderName: ParcelsTotal.toFixed(2),
			SenderGSTN: allNetAmountTotal.toFixed(2),
			BookCity: '',
		})
	}
	// cargoSettingFilterData IsMobNoInDispatchReport
	const tableData = bodyData.map((a) => {
		let DispatchDateTime = a?.DispatchDateTime?.split(' ') || ""
		const pdfLRNO = (a.OnlyLRNo || '') + (a?.ManualLR ? '\n' + a.ManualLR : '');
		const pdfVoucherNo = (a.VoucherNo || '') + (a?.PartyBillNo ? '\n' + a.PartyBillNo : '');
		const senderDetailes = (a.SenderName || '') + (a?.SenderMobileNo ? '\n' + a.SenderMobileNo : '') + (a?.SenderGSTN ? '\n' + a.SenderGSTN : '') + (a?.SenderEmailID ? '\n' + a.SenderEmailID : '')
		const senderDetailesWithoutNum = (a.SenderName || '') + (a?.SenderGSTN ? '\n' + a.SenderGSTN : '') + (a?.SenderEmailID ? '\n' + a.SenderEmailID : '')
		const recDetails = (a.RecName || '') + (a?.RecMobileNo ? '\n' + a.RecMobileNo : '') + (a?.ReceiverGSTN ? '\n' + a.ReceiverGSTN : '') + (a?.ReceiverEmailID ? '\n' + a.ReceiverEmailID : '');
		const recDetailsWithoutNum = (a.RecName || '') + (a?.ReceiverGSTN ? '\n' + a.ReceiverGSTN : '') + (a?.ReceiverEmailID ? '\n' + a.ReceiverEmailID : '');
		const pdfRecName = cargoSettingFilterData?.[0]?.IsMobNoInDispatchReport === 1 ? recDetailsWithoutNum : recDetails
		const SrcDestCity = (a.BookCity || '') + (a?.ToCity ? '\n' + a.ToCity : '')
		const DestCityBranch = (a.DispatchedToCityFilter || '') + (a?.DispatchedToBranchFilter ? '\n' + a.DispatchedToBranchFilter : '')
		const DispDT = (DispatchDateTime?.[0] || '') + (DispatchDateTime?.[1] ? '\n' + DispatchDateTime?.[1] : '');
		const PickupCityBrnach = (a.PickupCity || '') + (a?.PickupBranch ? '\n' + a.PickupBranch : '')
		return {
			...a,
			pdfLRNO,
			pdfVoucherNo,
			pdfRecName,
			senderDetailes,
			recDetails,
			SrcDestCity,
			DestCityBranch,
			DispDT,
			PickupCityBrnach

		};
	});
	if (key === 'PaymentType') {
		return tableData

	} else {
		setVehicleGroupData(tableData)
	}

}
const r2 = (n) => Math.round(n * 100) / 100
export const GroupDataVWC = (data) => {
	const result = [];
	data?.forEach(function (a) {
		if (!this[a.VehicleNo]) {
			this[a.VehicleNo] = {
				VehicleNo: a.VehicleNo,
				SummaryFromCity: '',
				SummaryToCity: '',
				//   ChartDate: '',
				Quantity: 0,
				paidFreight: 0,
				ToPayCodFreight: 0,
				OnAccountFreight: 0,
				DddvFreight: 0,
				FocFreight: 0,
				SelfFreight: 0,
				totalFreight: 0,
				SummaryAllCartage: 0,
				SummaryAllHamali: 0,
				SummaryAllOther: 0,
				SummaryInsurance: 0,
				SummaryServiceTaxAmount: 0,
				SummaryNetAmount: 0,
				UniqueTripNames: new Set(),
				UniqueTripIDs: new Set(),
				UniqueChartDate: new Set(),
			};
			result.push(this[a.VehicleNo]);
		}

		this[a.VehicleNo].SummaryFromCity = a.SummaryFromCity;
		this[a.VehicleNo].SummaryToCity = a.SummaryToCity;
		//   this[a.VehicleNo].ChartDate = a.ChartDate;
		this[a.VehicleNo].Quantity += a.Quantity;
		this[a.VehicleNo].paidFreight += a.paidFreight;
		this[a.VehicleNo].ToPayCodFreight += a.ToPayCodFreight;
		this[a.VehicleNo].OnAccountFreight += a.OnAccountFreight;
		this[a.VehicleNo].DddvFreight += a.DddvFreight;
		this[a.VehicleNo].FocFreight += a.FocFreight;
		this[a.VehicleNo].SelfFreight += a.SelfFreight;
		this[a.VehicleNo].totalFreight += a.totalFreight;
		this[a.VehicleNo].SummaryAllCartage += a.SummaryAllCartage;
		this[a.VehicleNo].SummaryAllHamali += a.SummaryAllHamali;
		this[a.VehicleNo].SummaryAllOther += a.SummaryAllOther;
		this[a.VehicleNo].SummaryInsurance += a.SummaryInsurance;
		this[a.VehicleNo].SummaryServiceTaxAmount += a.SummaryServiceTaxAmount;
		this[a.VehicleNo].SummaryNetAmount += a.SummaryNetAmount;
		this[a.VehicleNo].UniqueTripNames.add(a.TripName);
		this[a.VehicleNo].UniqueTripIDs.add(a.TripID);
		this[a.VehicleNo].UniqueChartDate.add(a.ChartDate);
	}, Object.create(null));
	result.forEach((entry) => {
		entry.UniqueTripNames = Array.from(entry.UniqueTripNames).join(', ');
		entry.UniqueTripIDs = Array.from(entry.UniqueTripIDs).join(', ');
		entry.UniqueChartDate = Array.from(entry.UniqueChartDate).join(', ');
		entry.SummaryNetAmount = Number(entry.SummaryNetAmount.toFixed(2));
		entry.SummaryAllOther = Number(entry.SummaryAllOther.toFixed(2));
		entry.dataType = 'entry';
	});
	let quantityTotal = 0
	let paidFreightTotal = 0
	let ToPayCodFreightTotal = 0
	let OnAccountFreightTotal = 0
	let DddvFreightTotal = 0
	let FocFreightTotal = 0
	let SelfFreightTotal = 0
	let AlltotalFreigh = 0
	let SummaryAllCartageTotal = 0
	let SummaryAllHamaliTotal = 0
	let SummaryAllOtherTotal = 0
	let SummaryInsuranceTotal = 0
	let SummaryServiceTaxAmountTotal = 0
	let SummaryNetAmountTotal = 0
	result.map((val) => {
		quantityTotal += Number(val.Quantity)
		paidFreightTotal += Number(val.paidFreight)
		ToPayCodFreightTotal += Number(val.ToPayCodFreight)
		OnAccountFreightTotal += Number(val.OnAccountFreight)
		DddvFreightTotal += Number(val.DddvFreight)
		FocFreightTotal += Number(val.FocFreight)
		SelfFreightTotal += Number(val.SelfFreight)
		AlltotalFreigh += Number(val.totalFreight)
		SummaryAllCartageTotal += Number(val.SummaryAllCartage)
		SummaryAllHamaliTotal += Number(val.SummaryAllHamali)
		SummaryAllOtherTotal += Number(val.SummaryAllOther)
		SummaryInsuranceTotal += Number(val.SummaryInsurance)
		SummaryServiceTaxAmountTotal += Number(val.SummaryServiceTaxAmount)
		SummaryNetAmountTotal += Number(val.SummaryNetAmount)
	})
	result.push({
		dataType: 'total',
		colSpan: { VehicleNo: 4 },
		VehicleNo: 'TOTAL AMOUNT',
		Quantity: quantityTotal,
		paidFreight: paidFreightTotal,
		ToPayCodFreight: ToPayCodFreightTotal,
		OnAccountFreight: OnAccountFreightTotal,
		DddvFreight: DddvFreightTotal,
		FocFreight: FocFreightTotal,
		SelfFreight: SelfFreightTotal,
		totalFreight: AlltotalFreigh,
		SummaryAllCartage: SummaryAllCartageTotal,
		SummaryAllHamali: SummaryAllHamaliTotal,
		SummaryAllOther: r2(SummaryAllOtherTotal),
		SummaryInsurance: SummaryInsuranceTotal,
		SummaryServiceTaxAmount: SummaryServiceTaxAmountTotal,
		SummaryNetAmount: r2(SummaryNetAmountTotal),
	})
	return result
}

export function GroupDataVWCSecond(data) {
	const groupedData = data.reduce((result, item) => {
		const key = `${item.VehicleNo}-${item.SummaryFromCityID}-${item.SummaryFromBranchID}-${item.SummaryToCityID}-${item.SummaryToBranchID}-${item.SummaryDispatchDateTime}`
		if (!result[key]) {
			result[key] = []
		}
		result[key].push(item)
		return result
	}, {})
	const flattenedData = Object.values(groupedData).map((group) => {
		const counts = group.reduce(
			(acc, item) => {
				switch (item.PaymentTypeInt) {
					case 1:
					case 6:
						acc.paidCount++
						break
					case 2:
					case 4:
					case 7:
						acc.topayCount++
						break
					case 3:
					case 8:
						acc.focCount++
						break
					case 5:
					case 10:
						acc.onAccountCount++
						break
					case 9:
						acc.topaydddvCount++
						break
					default:
						break
				}
				acc.totalLR++
				acc.totalQuantity += Number(item.Quantity)
				acc.totalToPayCodFreight += Number(item.ToPayCodFreight)
				acc.totalpaidFreight += Number(item.paidFreight)
				acc.totalOnAccountFreight += Number(item.OnAccountFreight)
				acc.totalFocFreight += Number(item.FocFreight) + Number(item.SelfFreight)
				acc.totalDddvFreight += Number(item.DddvFreight)
				acc.totalFreight += Number(item.totalFreight)
				acc.totalToPayCodGstOther += Number(item.ToPay || 0) - Number(item.ToPayCodFreight || 0)
				acc.totalpaidGstOther = r2(acc.totalpaidGstOther + r2(Number(item.Paid || 0) - Number(item.paidFreight || 0)))
				// acc.totalOnAccountGstOther += Number(item.OnAccount || 0) - Number(item.OnAccountFreight || 0)
				acc.totalOnAccountGstOther += Number(item.OnAccountGstOther || 0)
				acc.totalFocGstOther += Number(item.FocGstOther || 0)
				acc.totalTopayDddvGstOther += Number(item.TopayDddvGstOther || 0)
				// acc.totalFocGstOther += 0
				// acc.totalTopayDddvGstOther += 0
				acc.totalGstOther = r2(acc.totalGstOther + r2(Number(item.SummaryNetAmount) - Number(item.totalFreight)))
				acc.totalNetAmount = r2(acc.totalNetAmount + Number(item.SummaryNetAmount))
				return acc
			},
			{
				paidCount: 0, topayCount: 0, focCount: 0,
				onAccountCount: 0, topaydddvCount: 0,
				totalLR: 0, totalQuantity: 0,
				totalToPayCodFreight: 0, totalpaidFreight: 0,
				totalOnAccountFreight: 0, totalFocFreight: 0,
				totalDddvFreight: 0, totalFreight: 0,
				totalToPayCodGstOther: 0, totalpaidGstOther: 0,
				totalOnAccountGstOther: 0, totalFocGstOther: 0,
				totalTopayDddvGstOther: 0, totalGstOther: 0,
				totalNetAmount: 0,
			}
		)
		return {
			...group[0], ...counts,
			totalpaidGstOther: r2(counts.totalpaidGstOther),
			totalGstOther: r2(counts.totalGstOther),
			totalNetAmount: r2(counts.totalNetAmount),
			dataType: 'entry'
		}
	})

	const totals = flattenedData.reduce((acc, val) => {
		acc.topayCount += Number(val.topayCount)
		acc.paidCount += Number(val.paidCount)
		acc.onAccountCount += Number(val.onAccountCount)
		acc.focCount += Number(val.focCount)
		acc.topaydddvCount += Number(val.topaydddvCount)
		acc.totalLR += Number(val.totalLR)
		acc.totalQuantity += Number(val.totalQuantity)
		acc.totalToPayCodFreight += Number(val.totalToPayCodFreight)
		acc.totalpaidFreight += Number(val.totalpaidFreight)
		acc.totalOnAccountFreight += Number(val.totalOnAccountFreight)
		acc.totalFocFreight += Number(val.totalFocFreight)
		acc.totalDddvFreight += Number(val.totalDddvFreight)
		acc.totalFreight += Number(val.totalFreight)
		acc.totalToPayCodGstOther += Number(val.totalToPayCodGstOther)
		acc.totalpaidGstOther += r2(Number(val.totalpaidGstOther))
		acc.totalOnAccountGstOther += Number(val.totalOnAccountGstOther)
		acc.totalFocGstOther += Number(val.totalFocGstOther)
		acc.totalTopayDddvGstOther += Number(val.totalTopayDddvGstOther)
		acc.totalGstOther += r2(Number(val.totalGstOther))
		acc.totalNetAmount += r2(Number(val.totalNetAmount))
		return acc
	}, {
		topayCount: 0, paidCount: 0, onAccountCount: 0,
		focCount: 0, topaydddvCount: 0, totalLR: 0, totalQuantity: 0,
		totalToPayCodFreight: 0, totalpaidFreight: 0, totalOnAccountFreight: 0,
		totalFocFreight: 0, totalDddvFreight: 0, totalFreight: 0,
		totalToPayCodGstOther: 0, totalpaidGstOther: 0, totalOnAccountGstOther: 0,
		totalFocGstOther: 0, totalTopayDddvGstOther: 0, totalGstOther: 0,
		totalNetAmount: 0,
	})

	flattenedData.push({
		dataType: 'total',
		colSpan: { VehicleNo: 3 },
		VehicleNo: 'TOTAL AMOUNT',
		...totals,
		totalpaidGstOther: r2(totals.totalpaidGstOther),
		totalGstOther: r2(totals.totalGstOther),
		totalNetAmount: r2(totals.totalNetAmount),
	})
	return flattenedData
}

export const checkPaymentTypeIntInArray = (array) => {
	const result = {};

	paymentModes.forEach(mode => {
		result[mode.PaymentTypeInt] = array.some(
			booking => booking.PaymentTypeInt === mode.PaymentTypeInt
		);
	});

	return result;
}
export const fixColSpan = (headers, data, nonViewHeaders) => {
	const spans = divideInNIntegers(nonViewHeaders.length, headers.length)
	const headersWithSpan = headers.map((col, index) => ({
		...col,
		span: spans[index],
	}));

	const expandedColumns = [];

	headersWithSpan.forEach(col => {
		expandedColumns.push({ field: col.field, textAlign: col.textAlign });
		for (let i = 1; i < col.span; i++) {
			expandedColumns.push({ field: null });
		}
	});
	expandedColumns[0].mainHeader = true
	const returHead = [expandedColumns, headersWithSpan]
	const returnData = data.map(row => ({
		...row,
		colSpan: headersWithSpan.reduce((acc, col) => ({ ...acc, [col.field]: col.span }), {})
	}))
	return [returHead, returnData]
}	